// Already lazy — workspace index.tsx exports a lazy() default
import FaireSourceAbandonedCartNudgePage from "@faire/prototype-playground/workspace/jl/faire-source-abandoned-cart-nudge";
import FaireSourceBrandCartLittleSisterNudgePage from "@faire/prototype-playground/workspace/jl/faire-source-brand-cart-little-sister-nudge";
import FaireSourceCartInfoBannerPage from "@faire/prototype-playground/workspace/jl/faire-source-cart-info-banner";
import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

const FaireSourceCartOrganizationPage = lazy(
  () => import("../../pages/FaireSourceCartOrganizationPage/index")
);

const FaireSourceCartKeepShoppingCtaPage = lazy(
  () => import("../../pages/FaireSourceCartKeepShoppingCtaPage")
);

export function JeremyLeclercRoutes() {
  return (
    <Switch>
      <Route
        path="/jl/faire-source-abandoned-cart-nudge"
        component={FaireSourceAbandonedCartNudgePage}
      />
      <Route
        path="/jl/faire-source-brand-cart-little-sister-nudge"
        component={FaireSourceBrandCartLittleSisterNudgePage}
      />
      <Route
        path="/jl/faire-source-cart-info-banner"
        component={FaireSourceCartInfoBannerPage}
      />
      <Route
        path="/jl/faire-source-cart-keep-shopping-cta"
        component={FaireSourceCartKeepShoppingCtaPage}
      />
      <Route
        path="/jl/faire-source-cart-organization"
        component={FaireSourceCartOrganizationPage}
      />
    </Switch>
  );
}

export const slug = "jl";
